import { supabase } from '../../../lib/supabaseClient';

export async function getASP(aspId) {
  const { data, error } = await supabase
    .from('sale_purchase_agreements')
    .select('*')
    .eq('id', aspId)
    .single();

  if (error) throw error;
  return data;
}

export async function getASPByReservation(reservationId) {
  const { data, error } = await supabase
    .from('sale_purchase_agreements')
    .select('*')
    .eq('reservation_id', reservationId)
    .maybeSingle();

  if (error) throw error;
  return data;
}

export async function getBuyerASPs(buyerId) {
  const { data, error } = await supabase
    .from('sale_purchase_agreements')
    .select(`
      *,
      units(*),
      projects(*)
    `)
    .eq('buyer_id', buyerId)
    .order('created_at', { ascending: false });

  if (error) throw error;
  return data || [];
}

export async function getDeveloperASPs(developerId) {
  const { data, error } = await supabase
    .from('sale_purchase_agreements')
    .select(`
      *,
      units(*),
      projects(*),
      profiles!buyer_id(full_name, email)
    `)
    .eq('developer_id', developerId)
    .order('created_at', { ascending: false });

  if (error) throw error;
  return data || [];
}

export async function createASPFromReservation(reservationId, acknowledgedDisclaimer = false) {
  const { data, error } = await supabase
    .rpc('create_asp_from_reservation', {
      p_reservation_id: reservationId,
      p_buyer_acknowledged_disclaimer: acknowledgedDisclaimer
    });

  if (error) throw error;
  return data;
}

export async function updateASPStatus(aspId, newStatus, additionalFields = {}) {
  const updateData = {
    status: newStatus,
    ...additionalFields
  };

  if (newStatus === 'sent_to_lawyer') {
    updateData.sent_to_lawyer_at = new Date().toISOString();
  } else if (newStatus === 'ready_to_sign') {
    updateData.ready_to_sign_at = new Date().toISOString();
  } else if (newStatus === 'withdrawn') {
    updateData.withdrawn_at = new Date().toISOString();
  }

  const { data, error } = await supabase
    .from('sale_purchase_agreements')
    .update(updateData)
    .eq('id', aspId)
    .select()
    .single();

  if (error) throw error;
  return data;
}

export async function withdrawASP(aspId, reason) {
  const { data: { user } } = await supabase.auth.getUser();

  const { data, error } = await supabase
    .from('sale_purchase_agreements')
    .update({
      status: 'withdrawn',
      withdrawn_at: new Date().toISOString(),
      withdrawn_by: user.id,
      withdrawn_reason: reason
    })
    .eq('id', aspId)
    .select()
    .single();

  if (error) throw error;
  return data;
}

export async function generateASPDocument(aspId, format = 'html') {
  const { data, error } = await supabase.functions.invoke('generate-asp-document', {
    body: { asp_id: aspId, format }
  });

  if (error) throw error;
  return data;
}

export async function getASPDocuments(aspId) {
  const { data, error } = await supabase
    .from('asp_documents')
    .select('*')
    .eq('asp_id', aspId)
    .order('version', { ascending: false });

  if (error) throw error;
  return data || [];
}
